import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

// Components
import AdminNav from "./AdminNav";

// Data
import routes from "./adminRoutes";

// CSS
import "../../css/forms/form-fields.css";

class Admin extends Component {
	render() {
		return (
			<div className="full_body_container">
				<div className="sub_nav_wrapper">
					<div className="hbs-container-admin-nav">
						<AdminNav />
					</div>
				</div>
				<main className="content_wrapper">
					{
						<Switch>
							{routes.map((route, i) => (
								<Route key={i} {...route} />
							))}
						</Switch>
					}
				</main>
			</div>
		);
	}
}

export default Admin;



// WEBPACK FOOTER //
// ./src/components/admin/Admin.js